<template>
  <div
    class="flex shrink-0 overflow-x-auto overflow-y-hidden scrollbar-hide"
    :class="{ container: isContainered, 'space-x-4': isSpaced }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  container: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  spacedItems: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
})

const isContainered = computed(() => props.container)
const isSpaced = computed(() => props.spacedItems)
</script>
